import { Notice } from '@kollez/design-system';

/**
 * /group/students — group-wide student directory (index).
 *
 * MVP: renders an empty-state placeholder. The real list wires to
 * GET /group/students (cross-college aggregate over StudentProfile.tenant
 * ∈ subtree) and lands in a follow-up PR — the endpoint and DataTable
 * are the two remaining pieces.
 *
 * The /group/students/:id detail route is already live and reachable
 * from College detail rosters.
 */
export function GroupStudentsPage() {
  return (
    <div className="stack">
      <div className="page-header">
        <div className="ph-text">
          <p className="eyebrow">Institutions</p>
          <h1 className="h-page">Students</h1>
          <p className="subhead">Every student across every college under this tenant.</p>
        </div>
      </div>
      <Notice tone="info">
        <b>Directory in progress.</b> The cross-college student list is on the
        next PR. In the meantime, open a college from{' '}
        <a className="link" href="/group/colleges">
          Institutions
        </a>{' '}
        to see its roster.
      </Notice>
    </div>
  );
}
